import { useState } from 'react';
import { ParkingFilters, ParkingPrice } from '../../../domain/parking';
import { ParkingService } from '../../../services/parking';
import { computeParkingDate } from '../utils';

export const useParkingPrice = () => {
  const [parkingPrice, setParkingPrice] = useState<ParkingPrice | null>(null);
  const [isParkingAvailable, setIsParkingAvailable] = useState(true);

  const fetchParkingPrice = async (parkingFilters: ParkingFilters, lotId: number) => {
    try {
      const service = new ParkingService();
      const parkingPrice = await service.getParkingPrice({
        from_time: computeParkingDate(parkingFilters.entryDate, parkingFilters.entryTime),
        to_time: computeParkingDate(parkingFilters.exitDate, parkingFilters.exitTime),
        quantity_spots: 1,
        location_id: lotId.toString(),
      });

      /**
       * If parking is not available or number of vehicles is more than parking spots, an error about parking not available will be generated.
       */
      if (!parkingPrice.spots || parkingFilters.numberOfVehicles > parkingPrice.spots) {
        resetParkingPrice();
        setIsParkingAvailable(false);
        return null;
      }

      setParkingPrice(parkingPrice);

      return parkingPrice;
    } catch (error) {
      resetParkingPrice();
      setIsParkingAvailable(false);

      return null;
    }
  };

  const resetParkingPrice = () => {
    setParkingPrice(null);
  };

  const resetParkingAvailability = () => {
    setIsParkingAvailable(true);
  };

  return { parkingPrice, isParkingAvailable, fetchParkingPrice, resetParkingPrice, resetParkingAvailability };
};
